import React from 'react'
import Header from './header'
import HeaderLeft from './header-left'
import Sidebar from './sidebar'

const LayoutSet = () => {
  return (
    <>
      {/* <HeaderLeft /> */}
      <Sidebar />
      <Header />
    </>
  )
}

export default LayoutSet
